<template>
  <div>
    <b-form-group
      label-size="lg"
      label-cols="3"
      :disabled="disabled"
    >
      <template slot="label">
        1: Define hierarchy
      </template>
      <draggable v-model="levels">
        <SelectHierarchy
          v-for="level in levels"
          :key="level"
          :level="level"
          :v="validationForLevel(level)"
        />
      </draggable>
      <b-button
        v-if="useNLevels"
        class="col-6 offset-3"
        variant="primary"
        @click="upload.incrementLevelCount()"
      >
        Add level
      </b-button>
      <DisplayHierarchy />
      <DisplayNames />
    </b-form-group>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import HelpTooltip from '@/components/admin/upload/HelpTooltip.vue'
import SelectHierarchy from '@/components/admin/upload/CSVSettings/DefineHierarchy/SelectHierarchy.vue'
import DisplayHierarchy from '@/components/admin/upload/CSVSettings/DefineHierarchy/DisplayHierarchy.vue'
import DisplayNames from '@/components/admin/upload/CSVSettings/DefineHierarchy/DisplayNames.vue'
import { useUploadStore } from '@/store/admin/upload'
import draggable from 'vuedraggable'

const components = {
  HelpTooltip,
  SelectHierarchy,
  DisplayHierarchy,
  DisplayNames,
  draggable,
}

const props = {
  validationForLevel: {
    type: Function,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
}

@Component({ components })
export default class DefineHierarchy extends Vue.extend({ props }) {
  upload = useUploadStore()

  get useNLevels () {
    return this.$typedStore.features.useNLevels
  }

  get levels () {
    return this.upload.allLevels
  }

  set levels (updated) {
    this.upload.reorderLevels(updated)
  }
}

</script>
